import { Path } from '@/main/router/routerPath';

import { UzaverkaSkladu } from './uzaverkaSkladu';
import { UzaverkaObjednavekNd } from './uzaverkaObjednavekNd';
import { UzaverkaRozpracovanost } from './uzaverkaRozpracovanost';
import { UzaverkaPokladen } from './uzaverkaPokladen';
import { UzaverkaUcetni } from './uzaverkaUcetni';

export const router = new Path('Uzaverka').addChildren([
	UzaverkaSkladu.router,
	UzaverkaObjednavekNd.router,
	UzaverkaRozpracovanost.router,
	UzaverkaPokladen.router,
	UzaverkaUcetni.router,
]);
